import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import eastmanLogo from "./images/eastman.webp"; // Replace with actual paths
import dollarLogo from "./images/dollar.webp";
import nathLogo from "./images/nath.webp";

const testimonials = [
  {
    logo: eastmanLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Mr. Likhsab",
    position: "Director",
  },
  {
    logo: dollarLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Mr. Susan",
    position: "Director",
  },
  {
    logo: nathLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Mr. Morgen",
    position: "Director",
  },
  {
    logo: eastmanLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Mr. Alex",
    position: "CEO",
  },
  {
    logo: dollarLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Ms. Jessica",
    position: "Manager",
  },
  {
    logo: nathLogo,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus.",
    author: "Mr. Daniel",
    position: "Founder",
  }
];

// Group testimonials into sets of 3
const groupedTestimonials = [];
for (let i = 0; i < testimonials.length; i += 3) {
  groupedTestimonials.push(testimonials.slice(i, i + 3));
}

const TestimonialsSection = () => {
  return (
    <div className="testimonial-section py-5 container-fluid">
        <div className="wrapper">
        <div className="container">
        {/* Section Header */}
        <div className="text-center mb-4">
          <p className="testimonialtitle">TESTIMONIALS</p>
          <h2 className="testimonialtitle1">Made for Product people</h2>
          <p className="text-muted madepara">
            Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. <br></br>
            Duis aute irure dolor in reprehenderit.
          </p>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        {/* Carousel Section */}
        <Carousel indicators={false} controls={true} className="testimonial-carousel">
          {groupedTestimonials.map((group, index) => (
            <Carousel.Item key={index}>
              <div className="row">
                {group.map((testimonial, idx) => (
                  <div key={idx} className="col-md-4 d-flex justify-content-left">
                    <div className="testimonial-card p-4  shadow-sm bg-white">
                      <div className="logo mb-3">
                        <img src={testimonial.logo} alt="Company Logo" className="img-fluid" />
                      </div>
                      <p className="text-muted testimonialtext">{testimonial.text}</p>
                      <h5 className="fw-bold mt-3 author">{testimonial.author}</h5>
                      <p className="small text-muted authorpost">{testimonial.position}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
        </div>

    </div>
  );
};

export default TestimonialsSection;